import api, { authHeaders } from './base';

export const fetchInspectionList = async (page = 1, limit = 10, status = '', search = '') => {
    return await api.get('/inspection', {
        headers: authHeaders(),
        params: { page, limit, status, search: search.trim() || undefined },
    });
};

export const fetchInspectionById = async (id) => {
    return await api.get(`/inspection/${id}`, { headers: authHeaders() });
};

export const updateInspectionById = async (id, data) => {
    return await api.put(`/inspection/${id}`, data, { headers: authHeaders() });
};

export const inspectionStatusUpdate = async (id, status) => {
    return await api.put(`/inspection/${id}/status/${status}`, null, { headers: authHeaders() });
};